<template>
  <div class="line">
  </div>
</template>

<script>
  export default {
    name: 'LineVue'
  }
</script>

<style lang="scss" scoped>
  .line{
    width: 100%;
    height: 10px;
    background: linear-gradient(to left, #FD5353, #6B53FD);
  }
</style>